import { render, staticRenderFns } from "./fpzInvaccCommon.vue?vue&type=template&id=5cac66fe&scoped=true"
import script from "./fpzInvaccCommon.vue?vue&type=script&lang=js"
export * from "./fpzInvaccCommon.vue?vue&type=script&lang=js"
import style0 from "./fpzInvaccCommon.vue?vue&type=style&index=0&id=5cac66fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac66fe",
  null
  
)

export default component.exports